/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.js to modify the generation of this file.
import React from 'react';
import Loadable from 'react-loadable';
const AdvantageList = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/AdvantageList" */ '../components/../components/templates/AdvantageList'),
  loading: () => <div></div>,
  modules: ['../components/templates/AdvantageList'],
  });
const AgendaList = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/AgendaList" */ '../components/../components/templates/AgendaList'),
  loading: () => <div></div>,
  modules: ['../components/templates/AgendaList'],
  });
const ArticleCard = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/ArticleCard" */ '../components/../components/templates/ArticleCard'),
  loading: () => <div></div>,
  modules: ['../components/templates/ArticleCard'],
  });
const Banner = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/Banner" */ '../components/../components/templates/Banner'),
  loading: () => <div></div>,
  modules: ['../components/templates/Banner'],
  });
const BannerWithForm = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/BannerWithForm" */ '../components/../components/templates/BannerWithForm'),
  loading: () => <div></div>,
  modules: ['../components/templates/BannerWithForm'],
  });
const Calendar = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/Calendar" */ '../components/../components/templates/Calendar'),
  loading: () => <div></div>,
  modules: ['../components/templates/Calendar'],
  });
const CardList = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/CardList" */ '../components/../components/templates/CardList'),
  loading: () => <div></div>,
  modules: ['../components/templates/CardList'],
  });
const CareersList = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/CareersList" */ '../components/../components/templates/CareersList'),
  loading: () => <div></div>,
  modules: ['../components/templates/CareersList'],
  });
const CaseStudies = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/CaseStudies" */ '../components/../components/templates/CaseStudies'),
  loading: () => <div></div>,
  modules: ['../components/templates/CaseStudies'],
  });
const CaseStudyCard = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/CaseStudyCard" */ '../components/../components/templates/CaseStudyCard'),
  loading: () => <div></div>,
  modules: ['../components/templates/CaseStudyCard'],
  });
const ClientsList = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/ClientsList" */ '../components/../components/templates/ClientsList'),
  loading: () => <div></div>,
  modules: ['../components/templates/ClientsList'],
  });
const ColumnSplitter = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/ColumnSplitter" */ '../components/../components/templates/ColumnSplitter'),
  loading: () => <div></div>,
  modules: ['../components/templates/ColumnSplitter'],
  });
const ContactBanner = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/ContactBanner" */ '../components/../components/templates/ContactBanner'),
  loading: () => <div></div>,
  modules: ['../components/templates/ContactBanner'],
  });
const ContentBlock = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/ContentBlock" */ '../components/../components/templates/ContentBlock'),
  loading: () => <div></div>,
  modules: ['../components/templates/ContentBlock'],
  });
const ContentBlockWithCTA = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/ContentBlockWithCTA" */ '../components/../components/templates/ContentBlockWithCTA'),
  loading: () => <div></div>,
  modules: ['../components/templates/ContentBlockWithCTA'],
  });
const ContentCard = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/ContentCard" */ '../components/../components/templates/ContentCard'),
  loading: () => <div></div>,
  modules: ['../components/templates/ContentCard'],
  });
const ContentSection = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/ContentSection" */ '../components/../components/templates/ContentSection'),
  loading: () => <div></div>,
  modules: ['../components/templates/ContentSection'],
  });
const CookieBanner = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/CookieBanner" */ '../components/../components/templates/CookieBanner'),
  loading: () => <div></div>,
  modules: ['../components/templates/CookieBanner'],
  });
const Error = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/Error" */ '../components/../components/templates/Error'),
  loading: () => <div></div>,
  modules: ['../components/templates/Error'],
  });
const EventCardBanner = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/EventCardBanner" */ '../components/../components/templates/EventCardBanner'),
  loading: () => <div></div>,
  modules: ['../components/templates/EventCardBanner'],
  });
const FAQList = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/FAQList" */ '../components/../components/templates/FAQList'),
  loading: () => <div></div>,
  modules: ['../components/templates/FAQList'],
  });
const FeaturedCard = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/FeaturedCard" */ '../components/../components/templates/FeaturedCard'),
  loading: () => <div></div>,
  modules: ['../components/templates/FeaturedCard'],
  });
const FeaturedSession = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/FeaturedSession" */ '../components/../components/templates/FeaturedSession'),
  loading: () => <div></div>,
  modules: ['../components/templates/FeaturedSession'],
  });
const FeaturesHighlight = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/FeaturesHighlight" */ '../components/../components/templates/FeaturesHighlight'),
  loading: () => <div></div>,
  modules: ['../components/templates/FeaturesHighlight'],
  });
const FindUs = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/FindUs" */ '../components/../components/templates/FindUs'),
  loading: () => <div></div>,
  modules: ['../components/templates/FindUs'],
  });
const Footer = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/Footer" */ '../components/../components/templates/Footer'),
  loading: () => <div></div>,
  modules: ['../components/templates/Footer'],
  });
const Form = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/Form" */ '../components/../components/templates/Form'),
  loading: () => <div></div>,
  modules: ['../components/templates/Form'],
  });
const GlobalSearch = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/GlobalSearch" */ '../components/../components/templates/GlobalSearch'),
  loading: () => <div></div>,
  modules: ['../components/templates/GlobalSearch'],
  });
const Glossary = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/Glossary" */ '../components/../components/templates/Glossary'),
  loading: () => <div></div>,
  modules: ['../components/templates/Glossary'],
  });
const GoBackCta = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/GoBackCta" */ '../components/../components/templates/GoBackCta'),
  loading: () => <div></div>,
  modules: ['../components/templates/GoBackCta'],
  });
import Header from '../components/templates/Header';
const HeroBanner = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/HeroBanner" */ '../components/../components/templates/HeroBanner'),
  loading: () => <div></div>,
  modules: ['../components/templates/HeroBanner'],
  });
const HeroBannerv2 = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/HeroBannerv2" */ '../components/../components/templates/HeroBannerv2'),
  loading: () => <div></div>,
  modules: ['../components/templates/HeroBannerv2'],
  });
const HeroBannerV3 = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/HeroBannerV3" */ '../components/../components/templates/HeroBannerV3'),
  loading: () => <div></div>,
  modules: ['../components/templates/HeroBannerV3'],
  });
const HeroCarousel = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/HeroCarousel" */ '../components/../components/templates/HeroCarousel'),
  loading: () => <div></div>,
  modules: ['../components/templates/HeroCarousel'],
  });
const ImageGallery = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/ImageGallery" */ '../components/../components/templates/ImageGallery'),
  loading: () => <div></div>,
  modules: ['../components/templates/ImageGallery'],
  });
const ImageHighlight = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/ImageHighlight" */ '../components/../components/templates/ImageHighlight'),
  loading: () => <div></div>,
  modules: ['../components/templates/ImageHighlight'],
  });
const InfoCard = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/InfoCard" */ '../components/../components/templates/InfoCard'),
  loading: () => <div></div>,
  modules: ['../components/templates/InfoCard'],
  });
const InformationalBanner = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/InformationalBanner" */ '../components/../components/templates/InformationalBanner'),
  loading: () => <div></div>,
  modules: ['../components/templates/InformationalBanner'],
  });
const InformationalBannerV3 = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/InformationalBannerV3" */ '../components/../components/templates/InformationalBannerV3'),
  loading: () => <div></div>,
  modules: ['../components/templates/InformationalBannerV3'],
  });
const InformationalBannerV4 = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/InformationalBannerV4" */ '../components/../components/templates/InformationalBannerV4'),
  loading: () => <div></div>,
  modules: ['../components/templates/InformationalBannerV4'],
  });
const InformationalBannerWithForm = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/InformationalBannerWithForm" */ '../components/../components/templates/InformationalBannerWithForm'),
  loading: () => <div></div>,
  modules: ['../components/templates/InformationalBannerWithForm'],
  });
const JobListing = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/JobListing" */ '../components/../components/templates/JobListing'),
  loading: () => <div></div>,
  modules: ['../components/templates/JobListing'],
  });
const KeyList = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/KeyList" */ '../components/../components/templates/KeyList'),
  loading: () => <div></div>,
  modules: ['../components/templates/KeyList'],
  });
const LearningList = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/LearningList" */ '../components/../components/templates/LearningList'),
  loading: () => <div></div>,
  modules: ['../components/templates/LearningList'],
  });
const LogoList = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/LogoList" */ '../components/../components/templates/LogoList'),
  loading: () => <div></div>,
  modules: ['../components/templates/LogoList'],
  });
const ManagedOfferings = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/ManagedOfferings" */ '../components/../components/templates/ManagedOfferings'),
  loading: () => <div></div>,
  modules: ['../components/templates/ManagedOfferings'],
  });
const OfferingList = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/OfferingList" */ '../components/../components/templates/OfferingList'),
  loading: () => <div></div>,
  modules: ['../components/templates/OfferingList'],
  });
const OfficeList = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/OfficeList" */ '../components/../components/templates/OfficeList'),
  loading: () => <div></div>,
  modules: ['../components/templates/OfficeList'],
  });
const OurLeaders = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/OurLeaders" */ '../components/../components/templates/OurLeaders'),
  loading: () => <div></div>,
  modules: ['../components/templates/OurLeaders'],
  });
const OurPartners = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/OurPartners" */ '../components/../components/templates/OurPartners'),
  loading: () => <div></div>,
  modules: ['../components/templates/OurPartners'],
  });
const PartnershipRibbon = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/PartnershipRibbon" */ '../components/../components/templates/PartnershipRibbon'),
  loading: () => <div></div>,
  modules: ['../components/templates/PartnershipRibbon'],
  });
const Presenters = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/Presenters" */ '../components/../components/templates/Presenters'),
  loading: () => <div></div>,
  modules: ['../components/templates/Presenters'],
  });
const Publication = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/Publication" */ '../components/../components/templates/Publication'),
  loading: () => <div></div>,
  modules: ['../components/templates/Publication'],
  });
const PublicationV2 = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/PublicationV2" */ '../components/../components/templates/PublicationV2'),
  loading: () => <div></div>,
  modules: ['../components/templates/PublicationV2'],
  });
const RelatedCardList = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/RelatedCardList" */ '../components/../components/templates/RelatedCardList'),
  loading: () => <div></div>,
  modules: ['../components/templates/RelatedCardList'],
  });
const RevampGallery = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/RevampGallery" */ '../components/../components/templates/RevampGallery'),
  loading: () => <div></div>,
  modules: ['../components/templates/RevampGallery'],
  });
const RewampIndustries = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/RewampIndustries" */ '../components/../components/templates/RewampIndustries'),
  loading: () => <div></div>,
  modules: ['../components/templates/RewampIndustries'],
  });
const RewampWhatWeDo = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/RewampWhatWeDo" */ '../components/../components/templates/RewampWhatWeDo'),
  loading: () => <div></div>,
  modules: ['../components/templates/RewampWhatWeDo'],
  });
const RichTextDisplay = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/RichTextDisplay" */ '../components/../components/templates/RichTextDisplay'),
  loading: () => <div></div>,
  modules: ['../components/templates/RichTextDisplay'],
  });
const RoiForm = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/RoiForm" */ '../components/../components/templates/RoiForm'),
  loading: () => <div></div>,
  modules: ['../components/templates/RoiForm'],
  });
const SearchResults = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/SearchResults" */ '../components/../components/templates/SearchResults'),
  loading: () => <div></div>,
  modules: ['../components/templates/SearchResults'],
  });
const ServicesCarousel = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/ServicesCarousel" */ '../components/../components/templates/ServicesCarousel'),
  loading: () => <div></div>,
  modules: ['../components/templates/ServicesCarousel'],
  });
const ServicesList = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/ServicesList" */ '../components/../components/templates/ServicesList'),
  loading: () => <div></div>,
  modules: ['../components/templates/ServicesList'],
  });
const SessionCarousel = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/SessionCarousel" */ '../components/../components/templates/SessionCarousel'),
  loading: () => <div></div>,
  modules: ['../components/templates/SessionCarousel'],
  });
const SolutionRecommendations = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/SolutionRecommendations" */ '../components/../components/templates/SolutionRecommendations'),
  loading: () => <div></div>,
  modules: ['../components/templates/SolutionRecommendations'],
  });
const SolutionRecommender = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/SolutionRecommender" */ '../components/../components/templates/SolutionRecommender'),
  loading: () => <div></div>,
  modules: ['../components/templates/SolutionRecommender'],
  });
const SpeakerList = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/SpeakerList" */ '../components/../components/templates/SpeakerList'),
  loading: () => <div></div>,
  modules: ['../components/templates/SpeakerList'],
  });
const Stats = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/Stats" */ '../components/../components/templates/Stats'),
  loading: () => <div></div>,
  modules: ['../components/templates/Stats'],
  });
const StatsCardList = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/StatsCardList" */ '../components/../components/templates/StatsCardList'),
  loading: () => <div></div>,
  modules: ['../components/templates/StatsCardList'],
  });
const SubscribeUs = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/SubscribeUs" */ '../components/../components/templates/SubscribeUs'),
  loading: () => <div></div>,
  modules: ['../components/templates/SubscribeUs'],
  });
const Support = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/Support" */ '../components/../components/templates/Support'),
  loading: () => <div></div>,
  modules: ['../components/templates/Support'],
  });
const TabSection = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/TabSection" */ '../components/../components/templates/TabSection'),
  loading: () => <div></div>,
  modules: ['../components/templates/TabSection'],
  });
const TextCardList = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/TextCardList" */ '../components/../components/templates/TextCardList'),
  loading: () => <div></div>,
  modules: ['../components/templates/TextCardList'],
  });
const TextDetail = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/TextDetail" */ '../components/../components/templates/TextDetail'),
  loading: () => <div></div>,
  modules: ['../components/templates/TextDetail'],
  });
const TextDetailV2 = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/TextDetailV2" */ '../components/../components/templates/TextDetailV2'),
  loading: () => <div></div>,
  modules: ['../components/templates/TextDetailV2'],
  });
const Video = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/Video" */ '../components/../components/templates/Video'),
  loading: () => <div></div>,
  modules: ['../components/templates/Video'],
  });
const VideoBanner = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/VideoBanner" */ '../components/../components/templates/VideoBanner'),
  loading: () => <div></div>,
  modules: ['../components/templates/VideoBanner'],
  });
const VideoSpotlight = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/VideoSpotlight" */ '../components/../components/templates/VideoSpotlight'),
  loading: () => <div></div>,
  modules: ['../components/templates/VideoSpotlight'],
  });
const Workshop = Loadable({
  loader: () => import(/* webpackChunkName: "../components/templates/Workshop" */ '../components/../components/templates/Workshop'),
  loading: () => <div></div>,
  modules: ['../components/templates/Workshop'],
  });

const components = new Map();
components.set('AdvantageList', AdvantageList);
components.set('AgendaList', AgendaList);
components.set('ArticleCard', ArticleCard);
components.set('Banner', Banner);
components.set('BannerWithForm', BannerWithForm);
components.set('Calendar', Calendar);
components.set('CardList', CardList);
components.set('CareersList', CareersList);
components.set('CaseStudies', CaseStudies);
components.set('CaseStudyCard', CaseStudyCard);
components.set('ClientsList', ClientsList);
components.set('ColumnSplitter', ColumnSplitter);
components.set('ContactBanner', ContactBanner);
components.set('ContentBlock', ContentBlock);
components.set('ContentBlockWithCTA', ContentBlockWithCTA);
components.set('ContentCard', ContentCard);
components.set('ContentSection', ContentSection);
components.set('CookieBanner', CookieBanner);
components.set('Error', Error);
components.set('EventCardBanner', EventCardBanner);
components.set('FAQList', FAQList);
components.set('FeaturedCard', FeaturedCard);
components.set('FeaturedSession', FeaturedSession);
components.set('FeaturesHighlight', FeaturesHighlight);
components.set('FindUs', FindUs);
components.set('Footer', Footer);
components.set('Form', Form);
components.set('GlobalSearch', GlobalSearch);
components.set('Glossary', Glossary);
components.set('GoBackCta', GoBackCta);
components.set('Header', Header);
components.set('HeroBanner', HeroBanner);
components.set('HeroBannerv2', HeroBannerv2);
components.set('HeroBannerV3', HeroBannerV3);
components.set('HeroCarousel', HeroCarousel);
components.set('ImageGallery', ImageGallery);
components.set('ImageHighlight', ImageHighlight);
components.set('InfoCard', InfoCard);
components.set('InformationalBanner', InformationalBanner);
components.set('InformationalBannerV3', InformationalBannerV3);
components.set('InformationalBannerV4', InformationalBannerV4);
components.set('InformationalBannerWithForm', InformationalBannerWithForm);
components.set('JobListing', JobListing);
components.set('KeyList', KeyList);
components.set('LearningList', LearningList);
components.set('LogoList', LogoList);
components.set('ManagedOfferings', ManagedOfferings);
components.set('OfferingList', OfferingList);
components.set('OfficeList', OfficeList);
components.set('OurLeaders', OurLeaders);
components.set('OurPartners', OurPartners);
components.set('PartnershipRibbon', PartnershipRibbon);
components.set('Presenters', Presenters);
components.set('Publication', Publication);
components.set('PublicationV2', PublicationV2);
components.set('RelatedCardList', RelatedCardList);
components.set('RevampGallery', RevampGallery);
components.set('RewampIndustries', RewampIndustries);
components.set('RewampWhatWeDo', RewampWhatWeDo);
components.set('RichTextDisplay', RichTextDisplay);
components.set('RoiForm', RoiForm);
components.set('SearchResults', SearchResults);
components.set('ServicesCarousel', ServicesCarousel);
components.set('ServicesList', ServicesList);
components.set('SessionCarousel', SessionCarousel);
components.set('SolutionRecommendations', SolutionRecommendations);
components.set('SolutionRecommender', SolutionRecommender);
components.set('SpeakerList', SpeakerList);
components.set('Stats', Stats);
components.set('StatsCardList', StatsCardList);
components.set('SubscribeUs', SubscribeUs);
components.set('Support', Support);
components.set('TabSection', TabSection);
components.set('TextCardList', TextCardList);
components.set('TextDetail', TextDetail);
components.set('TextDetailV2', TextDetailV2);
components.set('Video', Video);
components.set('VideoBanner', VideoBanner);
components.set('VideoSpotlight', VideoSpotlight);
components.set('Workshop', Workshop);

export default function componentFactory(componentName) {
  return components.get(componentName);
};
